// Débrouillard — theme.js
document.addEventListener('DOMContentLoaded', function () {
  // Nav dropdown toggle (triggered by hamburger at every breakpoint)
  var burger = document.querySelector('.site-header__burger');
  var nav = document.querySelector('.site-header__nav');
  if (burger && nav) {
    burger.addEventListener('click', function (e) {
      e.stopPropagation();
      nav.classList.toggle('is-open');
    });
    document.addEventListener('click', function (e) {
      if (nav.classList.contains('is-open') && !nav.contains(e.target) && e.target !== burger) {
        nav.classList.remove('is-open');
      }
    });
  }

  // Search panel toggle
  var searchToggle = document.querySelector('.site-header__search-toggle');
  var searchPanel = document.querySelector('[data-search-panel]');
  if (searchToggle && searchPanel) {
    searchToggle.addEventListener('click', function () {
      searchPanel.classList.toggle('is-open');
      if (searchPanel.classList.contains('is-open')) {
        var input = searchPanel.querySelector('input');
        if (input) input.focus();
      }
    });
  }

  // Product gallery thumbnail switch
  document.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var full = thumb.getAttribute('data-full');
      var main = document.querySelector('[data-gallery-main]');
      if (main && full) main.src = full;
    });
  });

  // Quantity stepper
  document.querySelectorAll('[data-qty-wrapper]').forEach(function (wrapper) {
    var input = wrapper.querySelector('input');
    wrapper.querySelectorAll('[data-qty-step]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var step = parseInt(btn.getAttribute('data-qty-step'), 10);
        var val = Math.max(1, (parseInt(input.value, 10) || 1) + step);
        input.value = val;
      });
    });
  });

  initCartDrawer();
});

// ---- Cart drawer (AJAX) ----------------------------------------------

function bindCartDrawerEvents() {
  document.querySelectorAll('[data-cart-drawer-close]').forEach(function (el) {
    el.addEventListener('click', function (e) {
      e.preventDefault();
      closeCartDrawer();
    });
  });

  document.querySelectorAll('[data-cart-qty-change]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var line = parseInt(btn.getAttribute('data-line'), 10);
      var valueEl = btn.parentNode.querySelector('[data-cart-qty-value]');
      var current = parseInt(valueEl.textContent, 10) || 0;
      var step = parseInt(btn.getAttribute('data-cart-qty-change'), 10);
      updateCartLine(line, Math.max(0, current + step));
    });
  });

  document.querySelectorAll('[data-cart-remove]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      updateCartLine(parseInt(btn.getAttribute('data-line'), 10), 0);
    });
  });
}

function openCartDrawer() {
  var drawer = document.querySelector('[data-cart-drawer]');
  if (drawer) drawer.classList.add('is-open');
}

function closeCartDrawer() {
  var drawer = document.querySelector('[data-cart-drawer]');
  if (drawer) drawer.classList.remove('is-open');
}

function refreshCartDrawer(openAfter) {
  return fetch(window.location.pathname + '?section_id=cart-drawer')
    .then(function (res) { return res.text(); })
    .then(function (html) {
      var parser = new DOMParser();
      var doc = parser.parseFromString(html, 'text/html');
      var newDrawer = doc.querySelector('[data-cart-drawer]');
      var oldDrawer = document.querySelector('[data-cart-drawer]');
      if (newDrawer && oldDrawer) {
        if (oldDrawer.classList.contains('is-open')) newDrawer.classList.add('is-open');
        oldDrawer.replaceWith(newDrawer);
        bindCartDrawerEvents();
      }
      if (openAfter) openCartDrawer();
      updateCartCountBadge();
    });
}

function updateCartCountBadge() {
  fetch('/cart.js')
    .then(function (res) { return res.json(); })
    .then(function (cart) {
      var cartLink = document.querySelector('[data-cart-trigger]');
      if (!cartLink) return;
      var badge = cartLink.querySelector('.cart-count');
      if (cart.item_count > 0) {
        if (!badge) {
          badge = document.createElement('span');
          badge.className = 'cart-count';
          cartLink.appendChild(badge);
        }
        badge.textContent = cart.item_count;
      } else if (badge) {
        badge.remove();
      }
    });
}

function updateCartLine(line, quantity) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ line: line, quantity: quantity })
  }).then(function () { refreshCartDrawer(true); });
}

function initCartDrawer() {
  bindCartDrawerEvents();

  var cartTrigger = document.querySelector('[data-cart-trigger]');
  if (cartTrigger) {
    cartTrigger.addEventListener('click', function (e) {
      e.preventDefault();
      refreshCartDrawer(true);
    });
  }

  // Intercept product add-to-cart forms and add via AJAX instead of navigating
  document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var submitBtn = form.querySelector('[type="submit"]');
      if (submitBtn) submitBtn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      })
        .then(function (res) {
          if (!res.ok) return res.json().then(function (err) { throw err; });
          return res.json();
        })
        .then(function () {
          refreshCartDrawer(true);
        })
        .catch(function () {
          form.submit();
        })
        .finally(function () {
          if (submitBtn) submitBtn.disabled = false;
        });
    });
  });
}
